import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import id from "./locales/id.json";
import en from "./locales/en.json";
import my from "./locales/my.json";

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            id: { translation: id },
            en: { translation: en },
            my: { translation: my },
        },
        fallbackLng: "id",
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
